import React, { useState, useRef } from 'react';
import { Form, Button, Spinner, Image } from 'react-bootstrap';
import { uploadSurveyMainImage, deleteSurveyImage } from 'services/files';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

const UploadSurveyMainImage = ({ surveyId, onUploadSuccess, image_url }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentImageUrl, setCurrentImageUrl] = useState(image_url); // Estado para la URL de la imagen actual
  const fileInputRef = useRef(null); // Ref para el campo de entrada de archivo

  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!file) {
      toast.error('Por favor, selecciona una imagen antes de subir.', {
        theme: 'colored'
      });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('image', file);
    formData.append('surveyId', surveyId);

    try {
      const response = await uploadSurveyMainImage(formData, surveyId);
      if (response.result) {
        toast.success('Imagen subida exitosamente.', { theme: 'colored' });
        setFile(null); // Limpia el archivo seleccionado
        if (fileInputRef.current) {
          fileInputRef.current.value = ''; // Reinicia el campo de entrada de archivo
        }
        setCurrentImageUrl(response.image_url); // Actualiza la URL de la imagen
        if (onUploadSuccess) onUploadSuccess(response); // Llama al callback si se proporciona
      } else {
        toast.error(response.msg || 'Error al subir la imagen.', {
          theme: 'colored'
        });
      }
    } catch (error) {
      console.error('Error al subir la imagen:', error);
      toast.error(
        'Ocurrió un error inesperado. Por favor, inténtalo de nuevo.',
        { theme: 'colored' }
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteImage = async () => {
    if (!currentImageUrl) return;

    setLoading(true);

    try {
      const response = await deleteSurveyImage(surveyId);
      if (response.result) {
        toast.success('Imagen eliminada exitosamente.', { theme: 'colored' });
        setCurrentImageUrl(null); // Limpia la URL de la imagen actual
        if (onUploadSuccess) onUploadSuccess(null); // Llama al callback si se proporciona
      } else {
        toast.error(response.msg || 'Error al eliminar la imagen.', {
          theme: 'colored'
        });
      }
    } catch (error) {
      console.error('Error al eliminar la imagen:', error);
      toast.error(
        'Ocurrió un error inesperado. Por favor, inténtalo de nuevo.',
        { theme: 'colored' }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {currentImageUrl && (
        <div className="mb-3 text-center">
          <p className="text-muted mb-1">Imagen actual</p>
          <Image
            src={currentImageUrl}
            alt="Imagen actual"
            rounded
            fluid
            style={{ maxHeight: '200px', objectFit: 'cover' }}
          />
          <div className="mt-2">
            <Button
              variant="danger"
              size="sm"
              onClick={handleDeleteImage}
              disabled={loading}
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                'Eliminar Imagen'
              )}
            </Button>
          </div>
        </div>
      )}
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label className="fw-bold">Subir Imagen Principal</Form.Label>
          <Form.Control
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            ref={fileInputRef} // Asigna el ref al campo de entrada
            disabled={loading}
          />
        </Form.Group>
        <Button type="submit" variant="primary" disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : 'Subir Imagen'}
        </Button>
      </Form>
    </div>
  );
};

UploadSurveyMainImage.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onUploadSuccess: PropTypes.func,
  image_url: PropTypes.string
};

export default UploadSurveyMainImage;
